export default __webpack_public_path__ + "static/media/drugstore.57faf9e2.png";